<template>
  <div
    class="pcm-a-wrapper"
    id="pcm-a-wrapper"
    @click="closeDownloadMenu"
    @keydown.esc="closeDownloadMenu"
  >
    <div class="pcm-a-top-filter" aria-hidden="true"></div>
    <div class="pcm-a-stage" :style="stageStyle">
      <img class="pcm-a-hero" :src="hero" alt="" />
      <img class="pcm-a-cards" :src="cards" alt="" />

      <div class="pcm-a-title-wrap">
        <img class="pcm-a-title" :src="title" alt="" />
        <div class="pcm-a-subtitle">你的全彩成人漫画专属站</div>
      </div>

      <img class="pcm-a-logo" :src="logo" alt="妖精漫画" />
      <div class="pcm-a-contact-list">
        <button
          v-for="item in contactItems"
          :key="item.type"
          class="pcm-a-contact"
          type="button"
          :aria-label="item.label"
          @click.stop="toContact(item.url)"
        >
          <img
            class="pcm-a-contact-icon"
            :class="item.type"
            :src="item.icon"
            alt=""
          />
          <span>{{ item.label }}</span>
        </button>
      </div>

      <button
        class="pcm-a-cta"
        type="button"
        aria-label="立即免费看"
        @click.stop="toggleDownloadMenu"
      >
        <img :src="cta" alt="立即免费看" />
      </button>

      <div class="pcm-a-qr-row">
        <div class="pcm-a-qr-box">
          <button
            class="pcm-a-qr-code"
            type="button"
            title="点击可在电脑直接下载"
            :aria-expanded="downloadMenuOpen"
            @click.stop="toggleDownloadMenu"
          >
            <img :src="qrImg" alt="下载二维码" />
          </button>
          <div
            class="pcm-a-download-list"
            :class="{ 'pcm-a-download-list-open': downloadMenuOpen }"
            @click.stop
          >
            <button
              class="pcm-a-download"
              type="button"
              :tabindex="downloadMenuOpen ? 0 : -1"
              @click="getApkInfo('android')"
            >
              <span>
                <strong>安卓极速版</strong>
                <small>电脑直接下载</small>
              </span>
            </button>
            <button
              class="pcm-a-download"
              type="button"
              :tabindex="downloadMenuOpen ? 0 : -1"
              @click="getApkInfo('ios')"
            >
              <span>
                <strong>苹果极速版</strong>
                <small>电脑直接下载</small>
              </span>
            </button>
          </div>
        </div>
        <div class="pcm-a-qr-text">
          <div class="pcm-a-qr-title">安卓手机 建议使用UC浏览器扫码</div>
          <div class="pcm-a-qr-desc">
            安装提示：本平台主要收益为广告赞助，且保证APP安全无毒，因平台属于特殊行业，某些杀毒软件会误报毒提醒，如遇此类提醒请点击忽略。
          </div>
        </div>
      </div>

      <div class="pcm-a-ai-text">
        <img class="pcm-a-ai-star" :src="star" alt="" />
        <span>AI短剧全新上线</span>
        <img class="pcm-a-ai-star" :src="star" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/assets/images/pc1/a/hero.png";
import Title from "@/assets/images/pc1/a/title.png";
import Cards from "@/assets/images/pc1/a/cards.png";
import Logo from "@/assets/images/pc1/a/logo.png";
import Cta from "@/assets/images/pc1/a/cta.png";
import IconGroup from "@/assets/images/pc1/a/icon-group.png";
import IconBusiness from "@/assets/images/pc1/a/icon-business.png";
import IconChannel from "@/assets/images/pc1/a/icon-channel.png";
import Star from "@/assets/images/pc1/a/star.png";

export default {
  props: {
    qrImg: {
      type: String,
      default: ""
    },
    os: {
      type: [Object, String],
      default: () => ({})
    },
    configs: {
      type: Array,
      default: () => []
    },
    version: {
      type: String,
      default: "A"
    }
  },
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      hero: Hero,
      title: Title,
      cards: Cards,
      logo: Logo,
      cta: Cta,
      iconGroup: IconGroup,
      iconBusiness: IconBusiness,
      iconChannel: IconChannel,
      star: Star,
      downloadMenuOpen: false,
      stageStyle: {
        transform: "translate(-50%, -50%) scale(1)"
      }
    };
  },
  mounted() {
    this.syncStageScale();
    window.addEventListener("resize", this.syncStageScale);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncStageScale);
  },
  computed: {
    contactItems() {
      return [
        {
          type: "group",
          label: "官方群组",
          url: this.tgUrl,
          icon: this.iconGroup
        },
        {
          type: "business",
          label: "商务合作",
          url: this.swUrl,
          icon: this.iconBusiness
        },
        {
          type: "channel",
          label: "渠道合作",
          url: this.qdUrl,
          icon: this.iconChannel
        }
      ];
    }
  },
  watch: {
    configs: {
      immediate: true,
      handler(newValue = []) {
        this.tgUrl = "";
        this.potatoUrl = "";
        this.swUrl = "";
        this.qdUrl = "";
        newValue.forEach(item => {
          if (item.configType === "tg_group") {
            this.tgUrl = item.link;
          } else if (item.configType === "potato_group") {
            this.potatoUrl = item.link;
          } else if (item.configType === "sw_cooperate") {
            this.swUrl = item.link;
          } else if (item.configType === "qd_cooperate") {
            this.qdUrl = item.link;
          }
        });
      }
    }
  },
  methods: {
    getApkInfo(type) {
      this.$emit("getApkInfo", type);
    },
    toggleDownloadMenu() {
      this.downloadMenuOpen = !this.downloadMenuOpen;
    },
    closeDownloadMenu() {
      this.downloadMenuOpen = false;
    },
    toContact(url) {
      if (!url) return;
      window.open(url);
    },
    syncStageScale() {
      const scale = Math.min(
        window.innerWidth / 1920,
        window.innerHeight / 1080
      );
      this.stageStyle = {
        transform: `translate(-50%, -50%) scale(${scale})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.pcm-a-wrapper {
  background: #d8d6f4 url("../../../assets/images/pc1/a/bg.png") no-repeat
    center;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;
}

.pcm-a-top-filter {
  background: linear-gradient(0deg, rgba(102, 102, 102, 0) 0%, #2f1598 100%);
  height: 208px;
  left: 0;
  opacity: 0.67;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}

.pcm-a-stage {
  --pcm-w: 1920Px;
  --pcm-h: 1080Px;
  height: 1080Px;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform-origin: center center;
  width: 1920Px;
  z-index: 2;
}

.pcm-a-hero,
.pcm-a-cards,
.pcm-a-title,
.pcm-a-logo {
  display: block;
  pointer-events: none;
  position: absolute;
}

.pcm-a-hero {
  height: 100%;
  left: 38.5%;
  object-fit: contain;
  object-position: left bottom;
  top: 0;
  width: 39.583333%;
  z-index: 9;
}

.pcm-a-cards {
  height: 74.074074%;
  left: 62.5%;
  object-fit: contain;
  object-position: right top;
  top: 17%;
  width: 35.416667%;
  z-index: 5;
}

.pcm-a-logo {
  height: 7.12963%;
  left: 5.208333%;
  object-fit: contain;
  top: 3.981481%;
  width: 15.989583%;
  z-index: 50;
}

.pcm-a-contact-list {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: calc(var(--pcm-w) * 36 / 1920);
  height: 5.185185%;
  justify-content: flex-end;
  position: absolute;
  right: 5%;
  top: 3.981481%;
  z-index: 60;
}

.pcm-a-contact {
  align-items: center;
  appearance: none;
  background: linear-gradient(180deg, #b64ed6 0%, #5152db 50%, #50b9ff 100%);
  border: 1px solid rgba(149, 243, 245, 1);
  border-radius: 999px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
  font-size: calc(var(--pcm-w) * 20 / 1920);
  height: 100%;
  padding: 0 calc(var(--pcm-w) * 18 / 1920);
  white-space: nowrap;
  width: auto;
  -webkit-tap-highlight-color: transparent;

  span {
    white-space: nowrap;
  }
}

.pcm-a-contact-icon {
  display: block;
  filter: brightness(0) invert(1);
  flex-shrink: 0;
  margin-right: calc(var(--pcm-w) * 10 / 1920);
  object-fit: contain;

  &.group {
    height: calc(var(--pcm-h) * 33.5 / 1080);
    width: calc(var(--pcm-w) * 37.5 / 1920);
  }

  &.business {
    height: calc(var(--pcm-h) * 41 / 1080);
    width: calc(var(--pcm-w) * 45 / 1920);
  }

  &.channel {
    height: calc(var(--pcm-h) * 39 / 1080);
    width: calc(var(--pcm-w) * 39 / 1920);
  }
}

.pcm-a-title-wrap {
  height: 49.907407%;
  left: 3.697917%;
  pointer-events: none;
  position: absolute;
  top: 11.851852%;
  width: 45.78125%;
  z-index: 6;
}

.pcm-a-title {
  height: 100%;
  left: 0;
  object-fit: contain;
  top: 0;
  width: 100%;
}

.pcm-a-subtitle {
  bottom: 20%;
  color: rgba(26, 27, 114, 1);
  font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
  font-size: calc(var(--pcm-w) * 32 / 1920);
  font-weight: 500;
  left: 50%;
  line-height: 1;
  position: absolute;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 2;
}

.pcm-a-cta {
  appearance: none;
  background: transparent;
  border: 0;
  cursor: pointer;
  height: 11.064815%;
  left: 11.796875%;
  padding: 0;
  position: absolute;
  top: 56.5%;
  width: 29.635417%;
  z-index: 10;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
    position: static;
    width: 100%;
  }
}

.pcm-a-qr-row {
  align-items: stretch;
  bottom: 11.759259%;
  display: flex;
  gap: calc(var(--pcm-w) * 27 / 1920);
  height: calc(var(--pcm-h) * 222.5 / 1080);
  left: 9.166667%;
  position: absolute;
  z-index: 12;
}

.pcm-a-qr-box,
.pcm-a-qr-text {
  background: #fff;
  border: 1px solid rgba(186, 198, 255, 0.9);
  border-radius: calc(var(--pcm-w) * 28 / 1920);
  box-sizing: border-box;
}

.pcm-a-qr-box {
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: calc(var(--pcm-w) * 222.5 / 1920);
}

.pcm-a-qr-text {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: calc(var(--pcm-h) * 14 / 1080) calc(var(--pcm-w) * 16 / 1920);
  width: calc(var(--pcm-w) * 421.5 / 1920);
}

.pcm-a-qr-title {
  color: rgba(255, 60, 242, 1);
  font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
  font-size: calc(var(--pcm-w) * 25 / 1920);
  font-weight: 500;
  line-height: 1.35;
  margin-bottom: calc(var(--pcm-h) * 16 / 1080);
}

.pcm-a-qr-desc {
  color: rgba(46, 0, 0, 1);
  font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
  font-size: calc(var(--pcm-w) * 17 / 1920);
  font-weight: 400;
  line-height: 1.55;
}

.pcm-a-qr-code {
  appearance: none;
  background: #fff;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
  height: calc(var(--pcm-w) * 184 / 1920);
  left: 50%;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(var(--pcm-w) * 184 / 1920);
  z-index: 2;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
    width: 100%;
  }
}

.pcm-a-download-list {
  background: rgba(120, 25, 155, 0.9);
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: calc(var(--pcm-w) * 184 / 1920);
  left: 50%;
  opacity: 0;
  padding: 8px;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.2s ease;
  width: calc(var(--pcm-w) * 184 / 1920);
  z-index: 3;
}

.pcm-a-download-list-open {
  opacity: 1;
  pointer-events: auto;
}

.pcm-a-download {
  align-items: center;
  appearance: none;
  background: linear-gradient(180deg, #ff78d1, #b721dc);
  border: 1px solid #fff;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  min-height: 0;
  padding: 0 6px;

  span {
    align-items: center;
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    white-space: nowrap;
  }

  strong {
    font-size: 14px;
    font-weight: 700;
  }

  small {
    font-size: 9px;
    margin-top: 3px;
  }
}

.pcm-a-ai-text {
  align-items: center;
  bottom: 5%;
  color: rgba(68, 57, 128, 1);
  display: flex;
  font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
  font-size: calc(var(--pcm-w) * 46 / 1920);
  position: absolute;
  right: 2%;
  z-index: 8;
}

.pcm-a-ai-star {
  display: block;
  flex-shrink: 0;
  height: calc(var(--pcm-w) * 21 / 1920);
  margin: 0 calc(var(--pcm-w) * 7 / 1920);
  object-fit: contain;
  width: calc(var(--pcm-w) * 20 / 1920);
}
</style>
